import { asBoolean, cleanObject } from "../clientes/clienteForm";
export const emptyProduct = () => ({
  clave: "",
  descripcion: "",
  talla: "",
  alias_1: "",
  alias_2: "",
  codigo_barras_venta: "",
  codigo_barras_proveedor: "",
  comentarios: "",
  clave_producto_servicio_sat: "",
  id_prod_tipo: "",
  id_prod_marca: "",
  id_empresa_prod: "",
  id_productos_unidad_medida: "",
  id_moneda_venta: "",
  id_moneda_compra: "",
  precio: 0,
  iva: 16,
  ieps: 0,
  retenciones: 0,
  retenciones_iva: 0,
  retenciones_iva_compras: 0,
  isr_ventas: 0,
  precio_unitario_factura: 0,
  minimo: 0,
  maximo: 0,
  punto_reorden: 0,
  multiplo_compra: 1,
  dias_entrega: 0,
  dias_inventario_meta: 0,
  tipo_control_auxiliar: "N",
  nivmov_frecuencia: "A",
  nivmov_promedio: "A",
  peso: 0,
  alto: 0,
  largo: 0,
  ancho: 0,
  volumen: 0,
  afecta_inventario: true,
  disp_ptoventa: true,
  es_paquete: false,
  es_destacado: false,
  servicio_prorrateo: false,
  es_producto_terminado: false,
  lista_produccion: false,
  comercio_electronico: false,
  material_peligroso: false,
  exento_iva: false,
  estatus: true,
  tipo_stock: false,
  importacion: false,
  tiene_pedimento: false,
  tiene_caducidad: false,
  categorias: [],
  empresas: [],
  proveedores: [],
  preciosgrupos: [],
  prod_contenidos: [],
  prod_relacionados: [],
});
const normalizeRelation = (rows, key) =>
  (rows || []).map(({ pivot, ...row }) => ({
    ...row,
    ...pivot,
    [key]: row[key] ?? row.id,
  }));
export function normalizeProduct(response) {
  const source = response?.data?.data || response?.data || response || {};
  return {
    ...emptyProduct(),
    ...source,
    id_empresa_prod: source.id_empresa_prod ?? source.id_empresa ?? "",
    categorias: normalizeRelation(source.categorias, "id_prod_categoria"),
    empresas: normalizeRelation(source.empresas, "id_empresa"),
    proveedores: normalizeRelation(source.proveedores, "id_proveedor"),
    preciosgrupos: normalizeRelation(
      source.precios_grupos || source.preciosGrupos,
      "id_cliente_grupo",
    ),
    prod_contenidos: normalizeRelation(
      source.prod_contenidos || source.prodContenidos,
      "id_producto",
    ),
    prod_relacionados: normalizeRelation(
      source.prod_relacionados || source.prodRelacionados,
      "id_producto_relacionado",
    ),
  };
}
export function buildProductPayload(form) {
  const result = {};
  const defaults = emptyProduct();
  for (const key of Object.keys(defaults)) {
    const value = form[key];
    if (
      Array.isArray(defaults[key]) ||
      value == null ||
      (value === "" &&
        (key.startsWith("id_") || typeof defaults[key] !== "string"))
    )
      continue;
    result[key] =
      typeof defaults[key] === "boolean"
        ? asBoolean(value)
        : key.startsWith("id_") || typeof defaults[key] === "number"
          ? Number(value)
          : String(value).trim();
  }
  const mapped = {
    categorias: ["id_prod_categoria", "color_tag"],
    empresas: ["id_empresa", "minimo", "maximo", "punto_reorden"],
    proveedores: [
      "id_proveedor",
      "id_moneda_compra",
      "clave",
      "descripcion",
      "dias_entrega",
      "precio",
      "proveedor_principal",
    ],
    preciosgrupos: ["id_cliente_grupo", "monto"],
    prod_contenidos: ["id_producto", "cantidad"],
    prod_relacionados: ["id_producto_relacionado", "tipo_relacion"],
  };
  for (const [name, keys] of Object.entries(mapped)) {
    result[name] = (form[name] || []).map((row) => {
      const source = {
        ...row,
        ...row.pivot,
        [keys[0]]: row[keys[0]] ?? row.id,
      };
      return cleanObject(
        Object.fromEntries(
          keys.map((key) => [
            key,
            key.startsWith("id_") && source[key] != null
              ? Number(source[key])
              : source[key],
          ]),
        ),
      );
    });
  }
  // La empresa principal también determina el alcance del catálogo.
  if (
    result.id_empresa_prod &&
    !result.empresas.some((row) => row.id_empresa === result.id_empresa_prod)
  ) {
    result.empresas.push({
      id_empresa: result.id_empresa_prod,
      minimo: Number(form.minimo || 0),
      maximo: Number(form.maximo || 0),
      punto_reorden: Number(form.punto_reorden || 0),
    });
  }
  // Campo obligatorio del ERP, oculto en la app. Nunca reemplazar un factor existente válido.
  const factor = form.factor_conversion;
  result.factor_conversion = factor != null && String(factor).trim() !== "" &&
    Number.isFinite(Number(factor)) && Number(factor) >= 0 ? Number(factor) : 1;
  result.precios_grupos = result.preciosgrupos;
  delete result.preciosgrupos;
  return result;
}
export function validateProduct(form) {
  const errors = {};
  const required = [
    "clave",
    "descripcion",
    "id_prod_tipo",
    "id_prod_marca",
    "id_productos_unidad_medida",
    "id_moneda_compra",
    "id_moneda_venta",
  ];
  required.forEach((key) => {
    if (!String(form[key] ?? "").trim()) errors[key] = "Campo obligatorio.";
  });
  if (Number(form.multiplo_compra) < 1)
    errors.multiplo_compra = "Debe ser al menos 1.";
  if (Number(form.minimo) > Number(form.maximo) && Number(form.maximo) > 0)
    errors.maximo = "El máximo debe ser mayor o igual al mínimo.";
  for (const [name, value] of Object.entries(form)) {
    if (
      typeof emptyProduct()[name] === "number" &&
      (!Number.isFinite(Number(value)) || Number(value) < 0)
    )
      errors[name] = "Captura un número válido mayor o igual a cero.";
  }
  return errors;
}
